const COUNTRY_FLAGS: Record<string, string> = {
  "Australia": "🇦🇺",
  "Austria": "🇦🇹",
  "Azerbaijan": "🇦🇿",
  "Bahrain": "🇧🇭",
  "Belgium": "🇧🇪",
  "Brazil": "🇧🇷",
  "Canada": "🇨🇦",
  "China": "🇨🇳",
  "France": "🇫🇷",
  "Germany": "🇩🇪",
  "Hungary": "🇭🇺",
  "Italy": "🇮🇹",
  "Japan": "🇯🇵",
  "Mexico": "🇲🇽",
  "Monaco": "🇲🇨",
  "Netherlands": "🇳🇱",
  "Portugal": "🇵🇹",
  "Qatar": "🇶🇦",
  "Russia": "🇷🇺",
  "Saudi Arabia": "🇸🇦",
  "Singapore": "🇸🇬",
  "Spain": "🇪🇸",
  "Turkey": "🇹🇷",
  "UAE": "🇦🇪",
  "United Arab Emirates": "🇦🇪",
  "United Kingdom": "🇬🇧",
  "United States": "🇺🇸",
  "USA": "🇺🇸",
  "Vietnam": "🇻🇳",
  "South Africa": "🇿🇦",
  "Switzerland": "🇨🇭",
  "Sweden": "🇸🇪",
  "Malaysia": "🇲🇾",
  "India": "🇮🇳",
  "South Korea": "🇰🇷",
  "Thailand": "🇹🇭",
  "Las Vegas": "🇺🇸",
  "Miami": "🇺🇸",
};

export function getCountryFlag(countryName: string): string {
  return COUNTRY_FLAGS[countryName] ?? "🏁";
}
